export { PureCopyrightNotice } from './pureCopyrightNotice';
export { PolymorphicCopyrightNotice } from './polymorphicCopyrightNotice';
export { PolymorphicCopyrightNotice as CopyrightNotice } from './polymorphicCopyrightNotice';
export { PolymorphicCopyrightNotice as default } from './polymorphicCopyrightNotice';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-copyright-notice/es/index.js
// module id = null
// module chunks = 